import {
    createBottomTabNavigator
} from "@react-navigation/bottom-tabs";
import {
    createNativeStackNavigator
} from "@react-navigation/native-stack";
import {
    Home,
    Compass,
    UserRoundSearch
} from "lucide-react-native";
import {
    TabBar
} from "../../components";
import HomeScreen from "../../pages/app/home";
import GuestExplore from "../../pages/guest/guestExplore";
import ContactForm from "../../pages/app/contactForm";
import News from "../../pages/app/news";
import Announcements from "../../pages/app/announcements";
import NewsDetail from "../../pages/app/news/newsDetail";
import AnnouncementDetail from "../../pages/app/announcements/announcementsDetail";
import RestrictedView from "../../pages/guest/restrictedView";
import GuestEventDetail from "../../pages/guest/guestEventDetail";
import AboutPresident from "../../pages/app/aboutPresident";
import BoardDirectors from "../../pages/app/boardDirectors";
import PrivacyPolicy from "../../pages/app/privacyPolicy";
import OldPresidents from "../../pages/app/oldPresidents";
import MemberPolicy from "../../pages/app/memberPolicy";
import AboutUs from "../../pages/app/aboutUs";
import KVKK from "../../pages/app/kvkk";
import GuestApplyForm from "../../pages/guest/guestApplyForm";
import ScanQRGuest from "../../pages/guest/scanQRGuest";
import ThreeTTableInfo from "../../pages/common/threeTTableInfo";

const Tab = createBottomTabNavigator();
const Stack = createNativeStackNavigator();
const HomeStack = createNativeStackNavigator();

const GuestTabs = () => {
    return  <Tab.Navigator
        initialRouteName="HomeTab"
        tabBar={(props) => <TabBar
            {...props}
        />}
        screenOptions={{
            headerShown: false
        }}
    >
        <Tab.Screen
            name="HomeTab"
            component={GuestHomeStackNav}
            options={{
                tabBarLabel: "Ana Sayfa",
                tabBarIcon: ({
                    color,
                    size
                }) => <Home
                    color={color}
                    size={size}
                    strokeWidth={2.3}
                />
            }}
        />
        <Tab.Screen
            name="ExploreTab"
            component={GuestExplore}
            options={{
                tabBarLabel: "Keşfet",
                tabBarIcon: ({
                    color,
                    size
                }) => <Compass
                    color={color}
                    size={size}
                    strokeWidth={2.3}
                />
            }}
        />
        <Tab.Screen
            name="SearchTab"
            component={RestrictedView}
            options={{
                tabBarLabel: "Üye Arama",
                tabBarIcon: ({
                    color,
                    size
                }) => <UserRoundSearch
                    color={color}
                    size={size}
                    strokeWidth={2.3}
                />
            }}
        />
    </Tab.Navigator>;
};

const GuestHomeStackNav = () => {
    return <HomeStack.Navigator
        initialRouteName="Home"
        screenOptions={{
            headerShown: false
        }}
    >
        <HomeStack.Screen
            name="Home"
            component={HomeScreen}
        />
        <HomeStack.Screen
            name="News"
            component={News}
        />
        <Stack.Screen
            name="Announcements"
            component={Announcements}
        />
    </HomeStack.Navigator>;
};

const GuestStack = () => {
    return <Stack.Navigator
        screenOptions={{
            headerShown: false
        }}
    >
        <Stack.Screen
            name="MainTabs"
            component={GuestTabs}
        />
        <Stack.Screen
            name="Profile"
            component={RestrictedView}
        />
        <Stack.Screen
            name="CompanyDetail"
            component={RestrictedView}
        />
        <Stack.Screen
            name="Notifications"
            component={RestrictedView}
        />
        <Stack.Screen
            name="NewsDetail"
            component={NewsDetail}
        />
        <Stack.Screen
            name="AnnouncementDetail"
            component={AnnouncementDetail}
        />
        <Stack.Screen
            name="GuestEventDetail"
            component={GuestEventDetail}
        />
        <Stack.Screen
            name="GuestApplyForm"
            component={GuestApplyForm}
        />
        <Stack.Screen
            name="ContactFormForMembers"
            component={ContactForm}
        />
        <Stack.Screen
            name="AboutUs"
            component={AboutUs}
        />
        <Stack.Screen
            name="AboutPresident"
            component={AboutPresident}
        />
        <Stack.Screen
            name="BoardDirectors"
            component={BoardDirectors}
        />
        <Stack.Screen
            name="OldPresidents"
            component={OldPresidents}
        />
        <Stack.Screen
            name="PrivacyPolicy"
            component={PrivacyPolicy}
        />
        <Stack.Screen
            name="MemberPolicy"
            component={MemberPolicy}
        />
        <Stack.Screen
            name="KVKK"
            component={KVKK}
        />
        <Stack.Screen
            name="ScanQRGuest"
            component={ScanQRGuest}
        />
        <Stack.Screen
            name="ThreeTTableInfo"
            component={ThreeTTableInfo}
        />
    </Stack.Navigator>;
};
export default GuestStack;
